import moment from "moment";
import paginationComponent from "../../../components/pagination/pagination.component";
import { formats } from "../../../config/constants";
import IMEISNAnalysisDuplicationSOModel from "../../../models/imei-sn-analysis-duplication-so/imei-sn-analysis-duplication-so.model";
import ViewBase from "../../view-base.view";

/**
 * IMEI SN Analysis Duplication SO
 *
 *
 * @author cmc.kmduc1(Henry)
 */

const EXCEL_TYPE = {
  DUPLICATED_SO_COUNT: 'DUP',
  INPUT_USER_COUNT: 'USER'
}

const LOG_TYPES = {
  BY_INPUT_USER: {
    ID: 'DUP_PROMOTER',
    CODE: 'LT00001154',
    TEXT: 'by Input User',
  },
  BY_CHANNEL: {
    ID: 'DUP_CHANNEL',
    CODE: 'LT00001153',
    TEXT: 'by Channel',
  }
}

export default function IMEISNAnalysisDuplicationSOView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = Object.freeze({
    logWeek: moment().format(formats.WEEK_FORMAT),
    logType: LOG_TYPES.BY_INPUT_USER.ID
  });

  const DEFAULT_PAGINATION = Object.freeze({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  });

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let currentFilters = structuredClone(DEFAULT_FILTERS);

  let tableData = [];

  const getIMEISNAnalysisDuplicationSO = () => {
    this.showLoading();

    const body = {
      logWeek: moment(currentFilters.logWeek, formats.WEEK_FORMAT).format(
        formats.API_WEEK_FORMAT
      ),
      logType: currentFilters.logType,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    }

    IMEISNAnalysisDuplicationSOModel.getIMEISNAnalysisDuplicationSO(body)
      .then(result => {
        tableData = result.data
        pagination.pageIndex = result.pageIndex
        pagination.pageSize = result.pageSize
        pagination.totalItems = result.total
      })
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleSearchClick = (e) => {
    e.preventDefault();

    if (e.target.checkValidity()) {
      currentFilters = structuredClone(filters)
      pagination.pageIndex = 1

      getIMEISNAnalysisDuplicationSO()
    }

    e.target.classList.add("was-validated");
  }

  const handlePageIndexChange = (pageIndex) => {
    pagination.pageIndex = pageIndex
    getIMEISNAnalysisDuplicationSO()
  }

  const handlePageSizeChange = (pageIndex, pageSize) => {
    pagination.pageSize = pageSize
    pagination.pageIndex = pageIndex
    getIMEISNAnalysisDuplicationSO()
  }

  const handleExcelDownloadClick = (e) => {
    e.preventDefault()
    this.showLoading();

    const body = {
      logWeek: moment(currentFilters.logWeek, formats.WEEK_FORMAT).format(
        formats.API_WEEK_FORMAT
      ),
      logType: currentFilters.logType
    }

    IMEISNAnalysisDuplicationSOModel.imeiSNAnalysisDuplicationSOTotalExport(body)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleExcelDownloadDetailClick = (e, objectCode, excelType, fileName) => {
    e.preventDefault()

    this.showLoading()

    const body = {
      logWeek: moment(currentFilters.logWeek, formats.WEEK_FORMAT).format(
        formats.API_WEEK_FORMAT
      ),
      logType: currentFilters.logType,
      objectCode,
      excelType
    }

    IMEISNAnalysisDuplicationSOModel.imeiSNAnalysisDuplicationSODetailExport(body, fileName)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleChangeLogWeek = (e) => {
    filters.logWeek = e.target.value;
  }

  const handleChangeLogType = (e) => {
    filters.logType = e.target.value;
  }

  return {
    oninit: () => {
      getIMEISNAnalysisDuplicationSO()
    },

    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m(".card-body",
            m("form.row.g-2.needs-validation[novalidate]", {
              onsubmit: handleSearchClick
            },
              m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                m("label.form-label.mandatory[for=logWeek]",
                  this.getText("LT00000337", "Week")
                ),
                m('input.form-control', {
                  id: 'logWeek',
                  value: filters.logWeek,
                  required: true,
                  type: 'week',
                  onchange: handleChangeLogWeek
                }),
                m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
              ),
              m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                m("label.form-label.mandatory",
                  this.getText("LT00000117", "Type")
                ),
                m('div',
                  Object.values(LOG_TYPES).map((logTypeItem) => m(".form-check.form-check-inline",
                    {
                      onchange: (e) => handleChangeLogType(e),
                      key: logTypeItem.ID,
                    },
                    m(`input.form-check-input`,
                      {
                        id: logTypeItem.ID,
                        type: 'radio',
                        value: logTypeItem.ID,
                        name: `log-type-radio`,
                        checked: logTypeItem.ID == filters.logType
                      }
                    ),
                    m(`label.form-check-label[for=${logTypeItem.ID}]`, this.getText(logTypeItem.CODE, logTypeItem.TEXT))
                  )),
                )
              ),
              m(".col-12.d-flex.justify-content-end.gap-2",
                m("button.btn.btn-primary.cursor-pointer",
                  {
                    type: "submit",
                  },
                  this.getText("LT00000001", "Search")
                )
              )
            )
          )
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12.d-flex.justify-content-end",
                m('button.btn.btn-primary.cursor-pointer',
                  {
                    type: 'button',
                    onclick: handleExcelDownloadClick,
                    disabled: tableData.length == 0
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                )
              ),
              m(".col-12",
                m("table.table.table-bordered",
                  currentFilters.logType === LOG_TYPES.BY_INPUT_USER.ID ?
                    m("thead",
                      m("tr.align-middle.text-center",
                        m('th',
                          { colspan: 2, scope: 'col' },
                          this.getText("LT00000561", "Promoter")
                        ),
                        m('th',
                          { scope: 'col' },
                          this.getText("LT00001148", "Duplicated SO Count")
                        ),
                        m('th',
                          { scope: 'col' },
                          this.getText("LT00001149", "Input User Count")
                        )
                      )
                    ) :
                    m("thead",
                      m("tr.align-middle.text-center",
                        m('th',
                          { colspan: 2, scope: 'col' },
                          this.getText("LT00001150", "Channel")
                        ),
                        m('th',
                          { scope: 'col' },
                          this.getText("LT00001148", "Duplicated SO Count")
                        ),
                        m('th',
                          { scope: 'col' },
                          this.getText("LT00001149", "Input User Count")
                        )
                      )
                    ),
                  m("tbody",
                    tableData.length == 0 &&
                    m("tr.align-middle",
                      m("td[colSpan=4]",
                        this.getText("EM00000141", "No records found.")
                      )
                    ), tableData.map((data) =>
                      m("tr.align-middle",
                        m("td", m("span.cursor-text", data.objectCd)),
                        m("td", m("span.cursor-text", data.objectNm)),
                        m('td.text-center',
                          data.count > 0
                            ? m('a.btn.btn-link.p-0.cursor-pointer',
                              {
                                href: '#',
                                onclick: (e) => { handleExcelDownloadDetailClick(e, data.objectCd, EXCEL_TYPE.DUPLICATED_SO_COUNT, `${data.objectCd}-duplicated-so-count-${moment().format('YYYYMMDD-HHmmss')}.xlsx`) },
                                role: 'button'
                              }, data.count)
                            : m("span.cursor-text", data.count)
                        ),
                        m('td.text-center',
                          data.etcCount > 0
                            ? m('a.btn.btn-link.p-0.cursor-pointer',
                              {
                                href: '#',
                                onclick: (e) => { handleExcelDownloadDetailClick(e, data.objectCd, EXCEL_TYPE.INPUT_USER_COUNT, `${data.objectCd}-input-user-count-${moment().format('YYYYMMDD-HHmmss')}.xlsx`) },
                                role: 'button'
                              }, data.etcCount)
                            : m("span.cursor-text", data.etcCount)
                        ),
                      )
                    )
                  )
                ),
              ),
              tableData.length != 0 &&
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: handlePageIndexChange,
                  onPageSizeChanged: handlePageSizeChange
                })
              )
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
